<cx-search-bar (search)="searchAll($event)"
               [matAutocomplete]="autocomplete"
               [value]="selectedValue.asObservable()"
               [placeholder]="placeholder | translate"
               (keydown.enter)="closeAutocomplete()"
               #searchBar
               class="searchBar">
  <mat-autocomplete #autocomplete
                    autoActiveFirstOption="false"
                    (optionSelected)="onAutocompleteSelected($event.option.viewValue)">
    <mat-option *ngFor="let component of filteredAutocompleteOptions">
      {{component}}
    </mat-option>
  </mat-autocomplete>
</cx-search-bar>
